import type { SVGAttributes } from "react";

/**
 * A 6px dot at the 16px icon size, which the `@hightouch/htui` `DotIcon`
 * draws too small to read. Follows the same icon contract, so it works in
 * `Badge.svgIcon`.
 */
export const StatusDotIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    fill="currentColor"
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="4.5" />
  </svg>
);
